import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_URL } from '../config';
import { authFetch } from '../utils/authFetch';
import i18n from '../i18n';

export default function ResetPassword() {
  const lang = (i18n.resolvedLanguage || i18n.language || 'ru').slice(0,2);
  const query = new URLSearchParams(useLocation().search);
  const token = query.get('token');
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async e => {
    e.preventDefault();
    setError(null);
    try {
      const response = await authFetch(`${API_URL}/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword: password })
      });

      const data = await response.json();
      if (!response.ok) {
        throw new Error(data.message || 'Ошибка при сбросе пароля.');
      }

      setMessage('Пароль успешно обновлён!');
      setTimeout(() => navigate(`/login`), 3000);
    } catch (err) {
      setError(err.message);
    }
  };

  if (!token) {
    return (
      <div className="max-w-md mx-auto mt-10 p-4 border rounded-lg shadow">
        <p className="text-red-600">Некорректная или отсутствующая ссылка.</p>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto mt-10 p-4 border rounded-lg shadow">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1 font-medium">Новый пароль:</label>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
            className="w-full p-2 border rounded"
          />
        </div>
        {error && <p className="text-red-500">{error}</p>}
        {message && <p className="text-green-600">{message}</p>}
        <button
          type="submit"
          className="w-full py-2 bg-green-600 text-white rounded hover:bg-green-700"
        >
          Сохранить
        </button>
      </form>
    </div>
  );
}
